import * as React from 'react'

import { Box, type Colors, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

interface Props {
  color: Colors
  label?: string
  extraPadding?: number
  children: React.ReactNode
}

export const Milestone = observer(({ color, label, extraPadding = 0, children }: Props) => {
  /**
   * 16px: The gap between timeline and the content
   * 4px: Half the size of the dot
   * 2px: Dot wrapper padding
   * 1px: Half the timeline width
   * Total: Translate 23px
   */
  const defaultXPosition = 23
  const finalXposition = defaultXPosition + extraPadding
  const xPosition = `translateX(-${finalXposition}px)`
  return (
    <Box flexDirection="row" alignItems="center" style={{ position: 'relative' }} flexGrow>
      <Box
        style={{ position: 'absolute', transform: xPosition }}
        flexDirection="row"
        alignItems="center"
      >
        {label && (
          <Box
            minWidth="s64"
            textAlign="right"
            // TODO: Check if is possible to replace this transform with vanilla CSS and before
            style={{ position: 'absolute', transform: 'translateX(calc(-1 * (100% + 4px)))' }}
          >
            <Text.Normal weight="medium" size="100" color="grey800">
              {label}
            </Text.Normal>
          </Box>
        )}
        <Box
          width="s12"
          height="s12"
          background="grey000White"
          padding="s2"
          borderRadius={{ all: 'abs100' }}
        >
          <Box width="s8" height="s8" background={color} borderRadius={{ all: 'abs100' }} />
        </Box>
      </Box>
      {children}
    </Box>
  )
})
